export const MapProgressStrength = (progress: number): number => {
  switch (progress) {
    case 0: {
      return 0.02;
    }
    case 1: {
      return 0.35;
    }
    case 2: {
      return 0.75;
    }
    case 3: {
      return 1;
    }
    default: {
      return 0;
    }
  }
};
